import { Form } from "@redriver/cinnamon-mui";
import { resourceStatusLookup } from "modules/lookups";

const ResourceStatusDropdown = (props) => (
  <Form.Dropdown {...props} lookup={resourceStatusLookup} />
);

export default ResourceStatusDropdown;
